import type { Dictionary } from './ru'

export const en: Dictionary = {
  'common.currency': 'UZS',
  'common.amount': '{amount} UZS',
  'common.toCatalog': 'Back to catalog',
  'common.support': 'Contact support',
  'common.retry': 'Try again',
  'common.cancel': 'Cancel',
  'purchase.step': 'Step {step} of 3 · {name}',
  'purchase.stepAmount': 'Amount',
  'purchase.stepGreeting': 'Recipient and message',
  'purchase.stepPay': 'Payment',
  'howTo.title': 'How to send a gift',
  'howTo.sub': 'Story guide · 6 steps',
  'howTo.tipSub': "We'll show you in 6 short stories",
  'howTo.tipHide': 'Hide tip',

  'catalog.search': 'Search partners',
  'catalog.searchClear': 'Clear search',
  'catalog.allCategories': 'All',
  'catalog.categories': 'Categories',
  'catalog.priceFrom': 'from {amount}',
  'catalog.priceSingle': '{amount} UZS',
  'catalog.emptySearchTitle': 'Nothing found',
  'catalog.emptySearchText': 'Try a different name or category.',
  'catalog.emptyCategoryTitle': 'No partners in this category yet',
  'catalog.emptyCategoryText': 'Pick another category or check back later.',
  'catalog.emptyTitle': 'No partners yet',
  'catalog.emptyText': 'Gifts will appear here soon.',
  'catalog.resetFilters': 'Show all partners',
  'catalog.loadErrorTitle': "Couldn't load partners",
  'catalog.loadErrorOffline': 'Check your internet connection and try again.',
  'catalog.loadErrorText': 'Try again in a minute.',
  'catalog.loadMoreError': "Couldn't load more",

  'category.food': 'Food',
  'category.beauty': 'Beauty',
  'category.sport': 'Sport',
  'category.clothing': 'Clothing',
  'category.electronics': 'Electronics',
  'category.entertainment': 'Entertainment',
  'category.services': 'Services',
  'category.kids': 'Kids',

  'partner.pickAmount': 'Choose an amount',
  'partner.amountTitle': 'Amount',
  'partner.next': 'Next · {amount} UZS',
  'partner.note': 'The voucher never expires and arrives right after payment — you send it to chat yourself.',
  'partner.where': 'Where to use',
  'partner.unavailableTitle': 'Gifts are temporarily unavailable',
  'partner.unavailableText': "This partner can't be gifted right now. Check back later or pick another one.",
  'partner.notFoundTitle': 'Partner not found',
  'partner.notFoundText': 'The link expired or the partner no longer works with us.',

  'checkout.change': 'Change',
  'checkout.recipientName': "Recipient's name",
  'checkout.recipientPlaceholder': 'For example, Malika',
  'checkout.recipientNote': 'Your own name comes from your Telegram profile automatically.',
  'checkout.message': 'Message',
  'checkout.messagePlaceholder': 'A few warm words — the recipient will see them',
  'checkout.messageHint': 'Shown after the gift-opening animation.',
  'checkout.ideas': 'Ready-made messages',
  'checkout.idea1': 'Happy birthday!',
  'checkout.idea1Text': 'Happy birthday! May this year be full of joy and warm get-togethers.',
  'checkout.idea1Named': 'Happy birthday, {name}! May this year be full of joy and warm get-togethers.',
  'checkout.idea2': 'Congratulations!',
  'checkout.idea2Text': 'Congratulations! You earned it — may everything work out.',
  'checkout.idea2Named': 'Congratulations, {name}! You earned it — may everything work out.',
  'checkout.idea3': 'Thank you',
  'checkout.idea3Text': 'Thank you for everything — a small sign of big gratitude.',
  'checkout.idea3Named': 'Thank you for everything, {name} — a small sign of big gratitude.',
  'checkout.idea4': 'Happy holidays!',
  'checkout.idea4Text': 'Happy holidays! Wishing you lots of warmth and smiles.',
  'checkout.idea4Named': 'Happy holidays, {name}! Wishing you lots of warmth and smiles.',
  'checkout.idea5': 'Just because',
  'checkout.idea5Text': 'Just because — to make your day a little brighter.',
  'checkout.idea5Named': '{name}, this is just because — to make your day a little brighter.',
  'checkout.presetReplace': 'Replace your text with “{text}”?',
  'checkout.presetReplaceOk': 'Replace',
  'checkout.note': "You'll pick the payment method on the next step.",
  'checkout.toPay': 'Continue to payment',
  'checkout.pendingTitle': 'This gift is awaiting payment',
  'checkout.pendingText': "We haven't received confirmation from the payment system yet.",
  'checkout.pendingAction': 'Check payment',
  'checkout.paidTitle': 'This gift is already paid',
  'checkout.paidText': 'No need to pay again — just send it to a chat.',
  'checkout.paidAction': 'Open gift',
  'checkout.unavailableTitle': 'This gift is no longer available',
  'checkout.unavailableText': 'This amount is not on sale right now. Pick another gift in the catalog.',

  'pay.method': 'Payment method',
  'pay.methodClick': 'UZCARD or Humo card in the Click window',
  'pay.methodPayme': 'Card or Payme balance',
  'pay.methodFoot': "Payment happens on the payment system's secure page. Once the bank confirms it, this screen updates by itself.",
  'pay.payAmount': 'Pay · {amount} UZS',
  'pay.opening': 'Opening the payment provider…',
  'pay.openingHint': "Don't close the window, this takes a couple of seconds",
  'pay.retry': 'Retry payment',
  'pay.leaveConfirm': "The payment is still in progress. Leaving won't stop it: once the bank confirms, your gift will be waiting to be sent.",
  'pay.leave': 'Leave',
  'pay.stay': 'Stay',
  'pay.errorDailyCount': "You've already bought {limit} gifts today — that's the daily limit. Please try again tomorrow.",
  'pay.errorDailyAmount': "With this gift, today's purchases would exceed {limit} UZS — that's the daily limit. Pick a smaller amount or try again tomorrow.",
  'pay.errorProviderDown': "{provider} isn't responding right now. Please pick another payment method.",
  'pay.errorInProgress': 'The payment via {provider} is not finished yet. Wait for its result before paying another way.',
  'pay.errorInProgressAction': 'Back to payment',
  'pay.errorNetwork': 'No connection. Check your internet and try again.',
  'pay.errorUnknown': "Couldn't start the payment. Please try again.",
  'pay.giftKind': 'Gift certificate',
  'pay.price': 'Price',
  'pay.total': 'Total',

  'payWait.title': 'Waiting for payment',
  'payWait.text': 'Finish paying on the payment page — this screen updates by itself once the bank confirms.',
  'payWait.checkingTitle': 'Checking your payment',
  'payWait.checkingText': "The bank hasn't confirmed yet. It usually takes a couple of minutes — this screen updates by itself.",
  'payWait.stalledTitle': 'Payment not confirmed yet',
  'payWait.stalledText': "Confirmation is taking longer. Check again a bit later — the payment won't get lost.",
  'payWait.checkAgain': 'Check again',
  'payWait.reopen': 'Open the payment page',
  'payWait.timeLeft': 'The bill is valid for {time} more',
  'payWait.offline': "No connection — we'll check as soon as you're back online.",

  'paySuccess.title': 'Payment complete',
  'paySuccess.text': 'Your gift is ready. Tap “Send gift” and choose the chat with the recipient.',
  'paySuccess.send': 'Send gift',
  'paySuccess.recipient': 'Recipient',
  'paySuccess.order': 'Order number',
  'paySuccess.time': 'Time',
  'paySuccess.sendFallback': 'Open the chat with the recipient, type {bot} and pick the gift.',
  'paySuccess.sendFallbackNoBot': 'Open the chat with the recipient, type our bot name with @ and pick the gift.',
  'stories.step': 'Step {step} of 6',
  'stories.step1': 'Choose a gift card',
  'stories.step2': 'Set the amount and message',
  'stories.step3': 'Pay',
  'stories.step4': 'Tap “Send gift” and choose a chat',
  'stories.step5': 'Pick the gift from the list',
  'stories.step6': 'Send it',
  'stories.manualHint': 'or type {bot} in the chat and pick the gift',
  'stories.manualHintNoBot': 'or type our bot name with @ in the chat and pick the gift',
  'stories.gotIt': 'Got it',
  'stories.close': 'Close',
  'stories.prev': 'Previous step',
  'stories.next': 'Next step',

  'payCancel.title': 'Payment cancelled',
  'payCancel.text': 'Nothing was charged. Your gift draft is saved — you can return to payment.',

  'payFail.title': 'Payment failed',
  'payFail.notCharged': 'Nothing was charged.',
  'payFail.otherMethod': 'Another payment method',
  'payFail.insufficientFunds': 'The bank declined the transaction: insufficient funds.',
  'payFail.cardBlocked': 'The bank declined the transaction: the card is blocked.',
  'payFail.cardExpired': 'The bank declined the transaction: the card has expired.',
  'payFail.limitExceeded': 'The bank declined the transaction: the card limit is exceeded.',
  'payFail.declinedByBank': "The bank declined the transaction and didn't say why.",
  'payFail.cancelledByUser': 'The payment was cancelled on the payment page.',
  'payFail.timeout': 'The payment time ran out at the payment provider.',
  'payFail.providerError': 'The payment provider had a technical failure.',
  'payFail.unknown': "The payment provider declined the payment and didn't say why.",

  'payExpired.title': 'Payment time is up',
  'payExpired.text': 'Nothing was charged. Place the gift again — your message is saved.',
  'payExpired.restart': 'Place again',

  'payResult.notFoundTitle': 'Order not found',
  'payResult.notFoundText': 'The link expired or the order was placed from another account.',

  'unwrap.from': 'A gift for you from {name}',
  'unwrap.fromAnonymous': 'An anonymous gift for you',
  'unwrap.tapToOpen': 'Tap to open',
  'unwrap.opening': 'Opening your gift…',
  'unwrap.failedOffline': "No connection. Check your internet — the gift will open as soon as you're back online.",
  'unwrap.failed': "Couldn't open the gift. Try again in a minute.",

  /* Экран 09 — сцена GiftBox и карточка-сюрприз. Карточка без ответа бэкенда — без партнёра и суммы. */
  'unwrap.open': 'Open gift',
  'unwrap.what': "What's inside?",
  'unwrap.tease1': 'Maybe a voucher for your favorite store?',
  'unwrap.tease2': 'Or maybe warm words from {name}?',
  'unwrap.tease2Anonymous': 'Or maybe some warm words?',
  'unwrap.tease3': 'Open it and be the first to know!',
  'unwrap.reveal': 'A voucher for you!',
  'unwrap.revealSub': 'Your greeting is coming up',
  'reveal.genericTitle': 'Gift',
  'reveal.genericAmount': 'Voucher',
  'reveal.genericUnit': 'for you',

  'gift.takenTitle': 'Oops! Gift not found',
  'gift.takenText': "Someone else already opened it, or it's no longer available. Forwarded gifts don't work.",
  'gift.giveOwn': 'Send your own gift',
  'gift.notSentTitle': "This gift hasn't been delivered yet",
  'gift.notSentText': "The sender hasn't sent it to a chat yet or took it back. Ask them to send the gift again.",
  'gift.goneTitle': 'This gift is no longer available',
  'gift.goneText': 'The gift was cancelled and the voucher no longer works. If this is a mistake, contact support.',
  'gift.blockedTitle': 'This gift is temporarily unavailable',
  'gift.blockedText': "We're reviewing this gift. Contact support — we'll help sort it out.",
  'gift.ownBlocked': "The gift is temporarily unavailable: we're reviewing it.",
  'gift.giveMore': 'Send another gift',

  /* Экраны 10, 13, 14 — «Принять или отказаться» (БП-7, BE-51). Глагол отправителя — в настоящем времени: пол неизвестен. */
  'gift.decisionClosedTitle': 'The gift went back to the sender',
  'gift.decisionClosedText': 'It can no longer be accepted or declined: the time ran out, or you declined it on another device.',
  'decision.anonymous': 'Anonymous sender',
  'decision.sends': 'is sending you a gift',
  'decision.sentAt': '{date}, {time}',
  'decision.kind': 'Gift voucher',
  'decision.noExpiry': 'No expiry date',
  'decision.where': 'Where to use',
  'decision.acceptHint': 'Accept the gift to get a QR code you can pay with at the checkout.',
  'decision.deadline': "If you don't decide by {date}, {time}, the gift will go back to the sender.",
  'decision.accept': 'Accept gift',
  'decision.decline': 'Decline gift',
  'decision.declineConfirm': 'The gift will go back to the sender. Decline it?',
  'decision.declineYes': 'Decline',
  'decision.declineNo': 'Keep the gift',
  'decision.offline': 'No connection. Check your internet and tap again.',
  'decision.failed': 'Something went wrong. Try again in a minute.',
  'decision.declinedTitle': 'The gift went back to the sender',
  'decision.declinedText': "We'll let the sender know — the gift is theirs again, and they can give it to someone else.",
  'decision.toCatalog': 'To catalog',
  'voucher.accepted': 'Gift accepted',

  'voucher.from': '— {name}',
  'voucher.fromOnly': 'A gift from {name}',
  'voucher.qrLabel': 'Voucher QR code for the cashier',
  'voucher.copy': 'Copy',
  'voucher.usedTitle': 'This voucher has been used',
  'voucher.numberLabel': 'Voucher number',
  'voucher.howTo': 'How to use it',
  'voucher.howStep1': 'Tap “Show to cashier” — or read out the voucher number',
  'voucher.howStep2': 'The cashier scans it and confirms the amount',
  'voucher.howStep3': 'The voucher is used in full in a single purchase',
  'voucher.partnerNote': 'From the partner',
  'voucher.terms': 'Terms of use',
  'voucher.where': 'Where to use',
  'voucher.noLocations': "No locations are open right now. Contact support — we'll tell you where to use the voucher.",
  'voucher.offline': "No connection. The voucher is shown from your phone's memory — the QR code still works.",
  'voucher.offlineLoading': "No connection. The voucher will appear as soon as you're back online.",
  'voucher.doneTitle': 'Voucher redeemed',
  'voucher.undoText': "If the purchase didn't go through, ask the cashier to cancel the redemption — the voucher will be valid again. Later, only via support.",
  'voucher.cancelledTitle': 'Redemption cancelled',
  'voucher.cancelledText': 'The voucher is valid again. If you are still buying, show the QR code to the cashier once more.',

  /* Экраны 15–19: ваучер, QR для кассира, погашение и его отмена */
  'voucher.codeHint': "If the QR code won't scan, the cashier can enter this number manually",
  'voucher.qrHint': 'The cashier scans the QR code or enters the voucher number manually',
  'voucher.codeCopied': 'Code copied',
  'voucher.nominal': 'Value',
  'voucher.showButton': 'Show to cashier',
  'voucher.showButtonLabel': 'Show the QR code to the cashier',
  'voucher.showAgain': 'Show QR again',
  'voucher.close': 'Close',
  'voucher.doneText': 'The {amount} UZS voucher has been used.',
  'voucher.time': 'Time',
  'voucher.undoTitle': 'Can be undone until {time}',
  'voucher.done': 'Done',
  'voucher.usedAt': 'Used on {date}',
  'qr.done': 'Done',
  'qr.caption': '{brand} · {amount} UZS',
  'qr.waiting': 'Waiting for the cashier to scan…',

  'location.closedToday': 'Closed today',

  /* Экраны 11–12: «Где принимают», выбор навигатора */
  'location.open': 'Open',
  'location.until': 'until {time}',
  'location.closed': 'Closed',
  'location.opensAt': 'opens at {time}',
  'location.meters': '{value} m',
  'location.kilometers': '{value} km',
  'locations.search': 'Search by address or district',
  'locations.points.one': '{count} location',
  'locations.points.other': '{count} locations',
  'locations.countNearest': '{points} · nearest first',
  'locations.found': 'Found: {count}',
  'locations.hint': 'Tap a location to get directions in a navigation app.',
  'locations.showNearest': 'Show nearest',
  'locations.emptyTitle': 'No locations yet',
  'locations.notFound': 'Nothing found',
  'locations.notFoundSub': 'Try another address or district',
  'navigator.yandexNavi': 'Yandex Navigator',
  'navigator.yandexMaps': 'Yandex Maps',
  'navigator.googleMaps': 'Google Maps',
  'navigator.2gis': '2GIS',
  'navigator.default': 'default',
  'navigator.call': 'Call · {phone}',
  'navigator.copyAddress': 'Copy address',
  'navigator.addressCopied': 'Address copied',

  'notFound.title':'Page not found',
  'notFound.text': 'The link expired or the gift was deleted.',

  'reopenApp.title': 'Reopen the app',
  'reopenApp.text': 'The app has been open for too long. Close it and launch it again.',
  'reopenApp.draftKept': "The recipient's name and your message will be kept — they'll be filled in when you check out a gift again.",
  'reopenApp.close': 'Close the app',

  'accountBlocked.title': 'Account blocked',
  'accountBlocked.text': "The app isn't available for this account right now, but vouchers you bought or received still work. Contact support with the code below — we'll help you use them.",

  'appError.title': 'Something broke',
  'appError.text': 'We already got the error report. Reload the screen — your draft is saved.',
  'appError.reload': 'Reload screen',

  'netError.title': 'No connection',
  'netError.text': 'Check your internet and try again — the data will load automatically.',

  'settings.language': 'Language',
  'settings.theme': 'Theme',
  'settings.themeSystem': 'Same as Telegram',
  'settings.themeLight': 'Light',
  'settings.themeDark': 'Dark',

  /* Итерация 4: онбординг, профиль, язык, оформление, поддержка. */
  'onboarding.giftTitle': 'Gifts people remember',
  'onboarding.giftLead': 'Partner gift cards — all inside Telegram, no apps and no sign-up.',
  'onboarding.giftPoint1': 'The gift opens beautifully — like a real box',
  'onboarding.giftPoint2': 'Gift cards for shops, cafés and services',
  'onboarding.payTitle': 'Pay in seconds',
  'onboarding.payLead': "Click and Payme in the provider's secure window — your card details never reach us.",
  'onboarding.payPoint1': 'UZCARD and Humo cards — via Click and Payme',
  'onboarding.payPoint2': 'Purchase history with statuses',
  'onboarding.sendTitle': 'Your gift is ready ahead',
  'onboarding.sendLead': 'After paying, tap “Send gift” and pick a chat — the gift goes along with your greeting.',
  'onboarding.sendPoint1': 'Greeting inside the gift',
  'onboarding.sendPoint2': 'The recipient shows a QR code at the till',
  'onboarding.next': 'Next',
  'onboarding.start': 'Get started',
  'onboarding.skip': 'Skip',
  'onboarding.progress': 'Step {step} of {total}',

  'profile.title': 'Profile',
  'profile.statReceived': 'Gifts received',
  'profile.statGiven': 'Gifts given',
  'profile.language': 'Language',
  'profile.support': 'Support',

  'appearance.title': 'Appearance',
  'appearance.footer': '“Same as Telegram” — the theme switches together with the app.',

  'language.title': 'Language',
  'language.footer': 'The language applies to all screens at once. By default it comes from your Telegram profile. The bot will message you in this language too.',
  'language.uz': 'Uzbek',
  'language.ru': 'Russian',
  'language.en': 'English',

  'support.topic': 'Topic',
  'support.message': 'Message',
  'support.messageHint': "Describe what happened. Support's reply will appear in “My requests”.",
  'support.messagePlaceholder': "For example: the cashier couldn't scan the QR code",
  'support.send': 'Send',
  'support.sendDisabled': 'Write at least a few words',
  'support.sendOffline': 'No connection — the message was not sent. Your text is saved, try again.',
  'support.sendFailed': "Couldn't send. Please try again.",
  'support.gift': 'Gift',
  'support.giftHint': "We'll attach the gift to the request — no need to look up any number.",
  'support.myTickets': 'My requests',
  'support.sent': 'Request {number} sent',

  'ticket.kindPayment': 'Payment problem',
  'ticket.kindVoucher': 'Voucher not accepted',
  'ticket.kindRefund': 'Refund',
  'ticket.kindGeneral': 'Other question',
  'ticket.statusOpen': 'Open',
  'ticket.statusInProgress': 'In progress',
  'ticket.statusWaiting': 'Awaiting your reply',
  'ticket.statusResolved': 'Resolved',
  'ticket.statusClosed': 'Closed',
  'ticket.status': 'Status',
  'ticket.reply': 'Reply',
  'ticket.replyPlaceholder': 'Write a reply',
  'ticket.replyDisabled': 'Write a reply',
  'ticket.replySent': 'Reply sent',
  'ticket.closedHint': 'This request is closed. If you still have a question, create a new one.',
  'ticket.newTicket': 'New request',
  'ticket.notFoundTitle': 'Request not found',
  'ticket.notFoundText': 'The link may be outdated. Create a new request — we will help.',
  'ticket.emptyTitle': 'No requests yet',
  'ticket.emptySub': 'Your requests and support replies will appear here.',
  'ticket.authorYou': 'You',
  'ticket.authorSupport': 'Support',
  'profile.myGifts': 'My gifts',
  'profile.history': 'Order history',
  'myGifts.tabs': 'Which gifts to show',
  'myGifts.received': 'Received',
  'myGifts.give': 'To give',
  'myGifts.receivedFooter': 'Gifts you have opened. The code and QR are inside once you tap “Accept gift”.',
  'myGifts.giveFooter': 'Paid gifts are waiting to be sent: tap “Send gift” and choose a chat. A gift that was sent but not opened yet can be revoked.',
  'myGifts.emptyReceivedTitle': 'No gifts yet',
  'myGifts.emptyReceivedText': 'Gifts you receive will appear here as soon as you open the box.',
  'myGifts.emptyGiveTitle': 'Nothing to give',
  'myGifts.emptyGiveText': 'Buy a certificate in the catalog — it will wait here until you send it.',
  'giftList.title': '{brand} · {amount}',
  'giftList.from': 'from {name}',
  'giftList.fromAnonymous': 'anonymous',
  'giftList.loadErrorTitle': "Couldn't load gifts",
  'giftStatus.ready': 'Ready to send',
  'giftStatus.sent': 'Sent',
  'giftStatus.opened': 'Opened, awaiting reply',
  'giftStatus.accepted': 'Accepted',
  'giftStatus.redeemed': 'Redeemed',
  'giftStatus.blocked': 'Under review',
  'giftStatus.refunded': 'Refunded',
  'giftStatus.awaitingDecision': 'Awaiting your decision',
  'giftStatus.active': 'Active',
  'giftStatus.used': 'Used',
  'giftStatus.unavailable': 'Unavailable',
  'history.filters': 'Gift status',
  'history.all': 'All',
  'history.active': 'Active',
  'history.redeemed': 'Redeemed',
  'history.refunded': 'Refunds',
  'history.footer': 'All the gifts you have bought. Only the recipient sees the voucher code.',
  'history.emptyTitle': 'No purchases yet',
  'history.emptyText': 'Certificates you buy will appear here.',
  'history.emptyFilterTitle': 'Nothing here yet',
  'history.emptyFilterText': 'No gifts with this status.',
  'paySuccess.later': "I'll send it later — the gift stays in “My gifts”",

  'ownGift.status': 'Status',
  'ownGift.number': 'Gift number',
  'ownGift.orderNumber': 'Order number',
  'ownGift.timeline': 'Gift history',
  'ownGift.paidAt': 'Paid',
  'ownGift.sentAt': 'Sent to a chat',
  'ownGift.openedAt': 'Opened',
  'ownGift.claimedAt': 'Accepted',
  'ownGift.redeemedAt': 'Redeemed',
  'ownGift.refundedAt': 'Refunded',
  'ownGift.dateTime': '{date}, {time}',
  'ownGift.greeting': 'Message',
  'ownGift.anonymous': 'Unsigned — the gift is anonymous',
  'ownGift.stateReady': "The gift hasn't been sent yet. Tap “Send gift”, choose a chat and then this gift in the list.",
  'ownGift.stateSent': 'The gift is in the chat. Whoever taps “Open gift” first gets it.',
  'ownGift.stateOpened': 'The recipient opened the box and is deciding whether to accept the gift.',
  'ownGift.stateAccepted': 'The recipient accepted the gift. Only they can see the voucher code.',
  'ownGift.stateRedeemed': 'The gift was used at {place}.',
  'ownGift.stateRedeemedNoPlace': 'The gift was used.',
  'ownGift.stateRefunded': 'The money for this gift was refunded — it will reach your card within 1–7 days.',
  'ownGift.decisionTitle': 'Reply due by {date}, {time}',
  'ownGift.decisionText': "If there's no reply, the gift comes back to you. An opened gift can't be revoked.",
  'ownGift.revoke': 'Revoke gift',
  'ownGift.revokeFooter': 'The card in the chat will stop opening, and the gift will come back to you — you can send it again.',
  'ownGift.revokeConfirm': 'Revoke the gift? The card in the chat will stop opening.',
  'ownGift.revokeConfirmButton': 'Revoke',
  'ownGift.revoked': 'Gift revoked — it is back with you',
  'ownGift.revokeStale': "It can't be revoked anymore: the gift was opened or is no longer in the chat",
  'ownGift.refund': 'Get a refund',
  'ownGift.refundFooter': "The money goes back to the card you paid with within 1–7 days. After that the gift can't be sent.",
  'ownGift.refundConfirm': "Refund {amount} UZS? The money will reach the card you paid with within 1–7 days. This gift can't be sent after that.",
  'ownGift.refundConfirmButton': 'Get a refund',
  'ownGift.refunded': 'Refund issued — the money will reach your card within 1–7 days',
  'ownGift.refundStale': "A refund by button isn't available anymore: the gift was sent to a chat or already refunded",
  'ownGift.refundAlready': 'This gift has already been refunded',
  'ownGift.refundRejected': "The payment system didn't process the refund. The gift is still yours — try again later or contact support.",
  'ownGift.actionOffline': 'No connection. Check your internet and try again.',
  'ownGift.actionFailed': "That didn't work. Please try again.",
  'ownGift.supportFooter': 'For a gift that is already in a chat or with the recipient, refunds go through support.',
  'giftStatus.returned': 'Back with you',
  'ownGift.returnedAt': 'Came back to you',
  'ownGift.stateDeclined': 'The recipient declined the gift, so it is back with you. Send it to someone else or get a refund.',
  'ownGift.stateTimedOut': "The gift wasn't accepted within 7 days and came back to you. Send it again or get a refund.",
  'ownGift.stateRevoked': 'You revoked the gift — it is back with you. Send it again or get a refund.',
  'ownGift.sendAgain': 'Send again',
}
